module.exports = __webpack_public_path__ + "static/the-girls-c63d56f8aaaccdd9cfe342b60b6f6350.jpg";